/** Released host support. Keep download cards and assistant guidance in sync.
 * Reconciled with /api/plugin-updates and reachable installers on 2026-09-21.
 * Plugin release numbers/URLs remain in the download/update configuration.
 */
export const INTEGRATION_SUPPORT = {
  revit: { name: 'Revit', windows: ['2024', '2025', '2026'] },
  archicad: {
    name: 'Archicad',
    windows: ['27', '28', '29'],
    macos: ['28', '29'],
  },
  rhino: { name: 'Rhino', windows: ['8'] },
} as const;

export function buildIntegrationSupportGuidance(): string {
  return `## Available Arkyv integrations
Arkyv already supports these released integrations:
- Revit ${INTEGRATION_SUPPORT.revit.windows.join(', ')} on Windows.
- Archicad ${INTEGRATION_SUPPORT.archicad.windows.join(', ')} on Windows; ${INTEGRATION_SUPPORT.archicad.macos.join(', ')} on macOS.
- Rhino ${INTEGRATION_SUPPORT.rhino.windows.join(', ')} on Windows, including Grasshopper through the Rhino integration.

Product availability is separate from this chat's connection, entitlement, plugin version and command availability. A disconnected host or missing tool does not mean its integration is planned or unreleased. Only claim access to a live model when the current connection and available tools establish it.
Use this product information for integration availability questions even when no regulatory documents or live BIM host are connected. Use platformHelp for setup guidance when available. Installers are at [Downloads](/downloads); choose the host, operating system and version that match the user's installation. Do not invent support or launch dates for combinations outside this list (including Rhino on macOS, Archicad 27 on macOS and Revit 2027).`;
}
